import handleUrl from './lib/handle-url'

handleUrl()
